export default {
    ABERTO: 'Aberto',
    ENCERRADO: 'Encerrado',
    SUSPENSO: 'Suspenso',
    AGUARDANDO_ABERTURA: 'Aguardando Abertura'
}
